import React, { FunctionComponent, ReactElement, Ref, Suspense } from 'react';

import { BaseLoader } from '../../molecules/BaseLoader';
import { ExternalPortal } from '../../protons/ExternalPortal/ExternalPortal';

import { MODAL_SIZES } from './Modal.helpers';
import SubModal from './SubModal';

interface ModalProps {
  shouldCloseOnDimmerClick?: boolean;
  showCrossButton?: boolean;
  shouldShowPadding?: boolean;
  dataTestId?: string;
  icon?: ReactElement;
  onClose?: () => void;
  isOpen?: boolean;
  size?: MODAL_SIZES;
  forwardedRef?: Ref<HTMLDivElement>;
}

const Modal: FunctionComponent<React.PropsWithChildren<ModalProps>> = ({
  shouldCloseOnDimmerClick = true,
  size = MODAL_SIZES.MEDIUM,
  showCrossButton = true,
  shouldShowPadding = true,
  dataTestId = 'modal',
  children,
  isOpen = false,
  onClose,
  icon,
  forwardedRef,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Suspense fallback={<BaseLoader />}>
      <ExternalPortal>
        <SubModal
          forwardedRef={forwardedRef}
          shouldCloseOnDimmerClick={shouldCloseOnDimmerClick}
          shouldShowPadding={shouldShowPadding}
          showCrossButton={showCrossButton}
          dataTestId={dataTestId}
          onClose={onClose}
          icon={icon}
          size={size}
        >
          {children}
        </SubModal>
      </ExternalPortal>
    </Suspense>
  );
};

export default Modal;
